<template>
    <div v-if="logo && background" class="row container-login" ref="containerLogin" :class="{
        'fixed-action-btn': windowWidth < 700,
        'tela-vertical': windowWidth < 450 && windowWidth < windowHeight,
        'vertical-teclado-ativado': windowWidth < 450 && windowHeight < 450,
        'tela-horizontal': windowWidth > 450 && windowWidth < 700 && windowWidth > windowHeight,
        'horizontal-teclado-ativado': windowWidth < 700 && windowHeight < 250 && windowWidth > windowHeight
    }">
        <img :src="background" alt="plano de fundo" class="background-img" v-if="background" />
        <div :style="`background: url(${background});`" alt="plano de fundo" class="background-img" v-if="background">
        </div>
        <div class="fullHeight row col s12 ma-0">
            <div class="col s12 sub-container" :class="{ 'pr-0 pl-0 pt-1': sch.show_on_small }">
                <div class="col s12 m12 l6 pa-0 sub-container-logo" v-if="!showFormLead">
                    <div class="logo right col s12">
                        <div class="col s12 p-0 center">
                            <img :src="logo" alt="logomarca">
                        </div>
                        <span class="col s12 p-0 ma-0 center">Ainda n&atilde;o tem um login?</span>
                        <a id="btn-logar" href="#btn-buscar-email-cliente"
                            class="btn waves-effect waves-light col s12 negrito" @click="queroAcessar">CADASTRE-SE
                            AQUI!</a>
                    </div>
                </div>
                <div class="col s12 m12 pa-0 sub-container-form-login"
                    :class="showFormLead ? 'centralize-forced' : 'l6'">
                    <div class="card card-login col s12 pt-0"
                        :class="{ 'm6': !showFormLead, 'center_container': showFormLead && sch.show_on_medium_and_up }">
                        <div v-if="env && env.app_version" class="col s12 right-align primary-color-text"
                            style="opacity: .5;">
                            v{{ env.app_version }}
                        </div>
                        <template v-if="exibirPaginaLogin">
                            <p class="col s12 p-0 primary-color-text center title-form-login">Oi, fa&ccedil;a seu login
                                aqui!</p>
                            <form data-vv-scope="formLogin" class="formLogin">
                                <input type="hidden" name="client_id" value="SITE" />
                                <input type="hidden" name="grant_type" value="password" />
                                <div class="row margin">
                                    <div class="input-field col s12">
                                        <i class="material-icons prefix primary-color center white-text">person</i>
                                        <input class="field-color col s12 primary-color white-text" id="username"
                                            name="username" v-model.trim="obj_auth.username" type="text"
                                            :class="{ 'invalid': errors.has('username') }" data-vv-as="Login/Email">
                                        <label class="white-text" for="username"
                                            :data-error="errors.first('username')">Login/Email</label>
                                    </div>
                                </div>
                                <div class="row margin">
                                    <div class="input-field col s12">
                                        <i class="material-icons prefix primary-color center white-text">lock</i>
                                        <input class="field-color col s12 primary-color white-text mb-2" id="password"
                                            name="password" type="password" v-model="obj_auth.password"
                                            @keyup.enter="efetuarLogin" :class="{ 'invalid': errors.has('password') }"
                                            data-vv-as="senha">
                                        <label class="white-text" for="password"
                                            :data-error="errors.first('password')">Senha</label>
                                        <div class="flexbox sub-container-remember-me col s12 p-0 m-0">
                                            <div>
                                                <input type="checkbox" id="remember-me" v-model="lembrar" />
                                                <label for="remember-me">Lembrar meu login</label>
                                            </div>
                                            <div>
                                                <a @click.prevent="esqueciSenha" href="#">Esqueci a minha senha</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="input-field center col s12">
                                        <a @click.prevent="efetuarLogin" id="btn-logar"
                                            class="col s12 btn waves-effect waves-light negrito ma-0"
                                            :class="{ 'disabled': loaderLogin.length > 0 }">ENTRAR</a>
                                        <spinner-loader :pilha="loaderLogin" />
                                    </div>
                                </div>
                                <div class="row"></div>
                            </form>
                        </template>
                        <template v-if="esqueceuSenha">
                            <template>
                                <form data-vv-scope="formEsqueciSenha" id="formEsqueciSenha">
                                    <div class="row">
                                        <div class="container col s12 p-0">
                                            <p class="col s12" v-if="textoRetornoRecuperarSenha">{{ msg_modal }}</p>
                                            <p class="col s12" v-else>Digite o email associado à sua conta para que
                                                possamos enviar um link de recuperação de senha.</p>
                                            <div class="input-field col s12"
                                                :class="{ 'preto_branco': textoRetornoRecuperarSenha }">
                                                <i
                                                    class="material-icons prefix primary-color white-text">mail_outline</i>
                                                <input v-model="emailRecuperacaoSenha" ref="email" id="email"
                                                    name="email" type="text" v-validate="{ rules: { required: true } }"
                                                    class="col s12 primary-color white-text"
                                                    :class="{ 'invalid': errors.has('email') }"
                                                    :disabled="textoRetornoRecuperarSenha"><label for="email"
                                                    :data-error="errors.first('email')"
                                                    class="left-align white-text">Email</label>
                                            </div>
                                            <div class="input-field col s12" v-if="textoRetornoRecuperarSenha">
                                                <i class="material-icons prefix primary-color white-text">person</i>
                                                <input v-model="loginRecuperacaoSenha" ref="login" id="login"
                                                    name="login" type="text" v-validate="{ rules: { required: true } }"
                                                    class="col s12 primary-color white-text ma-0"
                                                    :class="{ 'invalid': errors.has('login') }"
                                                    style="padding-left: 3.5rem; box-sizing: border-box; margin-bottom: 10px;">
                                                <label for="login" :data-error="errors.first('login')"
                                                    class="left-align white-text">Login</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12 center">
                                            <spinner-loader :pilha="loaderEsqueciSenha" />
                                        </div>
                                    </div>
                                    <div class="divider mb-1"></div>
                                    <div class="row">
                                        <div class="col s12">
                                            <a @click.prevent="voltarPagLogin" id="btn-logar"
                                                class="btn waves-effect waves-light col s4 ma-0 left">Voltar</a>
                                            <div class="col s4"></div>
                                            <a @click.prevent="recuperarSenha" id="btn-logar"
                                                class="btn waves-effect waves-light col s4 ma-0 right"
                                                :class="{ 'disabled': loaderEsqueciSenha.length > 0 }"><i
                                                    class="material-icons">send</i></a>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="container">
                                            <div v-if="mensagem_esqueci_senha" id="card-alert-login"
                                                class="card red lighten-5">
                                                <div class="card-content red-text">
                                                    <p>{{ mensagem_esqueci_senha }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </template>
                        </template>
                        <template v-if="leadCliente">
                            <form data-vv-scope="formQueroAcessar">
                                <div class="row">
                                    <div class="col s12 pa-0">
                                        <form>
                                            <div class="row">
                                                <p class="col s12 ma-0">{{ tituloFuncaoQueroAcessar }}</p>
                                                <div class="col s12 pa-0">
                                                    <div class="input-field col s12">
                                                        <input type="text" name="CNPJ" id="clienteCNPJ"
                                                            ref="clienteCNPJ" class="primary-color white-text ma-0"
                                                            :class="{ 'invalid': errors.has('CNPJ') }"
                                                            v-validate="{ required: true, cnpj: true }"
                                                            v-model="cnpjCliente" />
                                                        <label class="white-text" for="clienteCNPJ"
                                                            :data-error="errors.first('CNPJ')">CNPJ</label>
                                                    </div>
                                                    <template v-if="showFormLead">
                                                        <div class="input-field col s12">
                                                            <input type="text" id="lead-contato" name="Nome"
                                                                v-model="lead.leadContato" v-validate="{ required: true }"
                                                                :class="{ 'invalid': errors.has('lead-contato') }"
                                                                class="validate ma-0" />
                                                            <label for="lead-contato"
                                                                :data-error="errors.first('Nome')">Informe o seu
                                                                nome</label>
                                                        </div>
                                                        <div class="input-field col s12">
                                                            <input type="text" id="lead-nome-empresa" name="Empresa"
                                                                v-model="lead.leadNomeEmpresa"
                                                                v-validate="{ required: true }"
                                                                :class="{ 'invalid': errors.has('lead-nome-empresa') }"
                                                                class="validate ma-0" />
                                                            <label for="lead-nome-empresa"
                                                                :data-error="errors.first('Empresa')">Informe o nome da
                                                                sua empresa</label>
                                                        </div>
                                                        <div class="input-field col s12">
                                                            <input id="lead-telefone" ref="leadTelefone" type="text"
                                                                name="Telefone" class="validate ma-0"
                                                                :class="{ 'invalid': errors.has('lead-telefone') }"
                                                                v-validate="{ rules: { required: true } }"
                                                                v-model="lead.leadTelefone" maxlength="16"
                                                                @keyup="formataTelefone" />
                                                            <label for="lead-telefone"
                                                                :data-error="errors.first('Telefone')">Informe o seu
                                                                telefone</label>
                                                        </div>
                                                        <div class="input-field col s12">
                                                            <input type="email" id="lead-email" name="Email"
                                                                v-model="lead.leadEmail"
                                                                v-validate="{ rules: { required: true, max: 128, email: true } }"
                                                                :class="{ 'invalid': errors.has('lead-email') }"
                                                                class="validate" />
                                                            <label for="lead-email"
                                                                :data-error="errors.first('Email')">Informe um
                                                                email</label>
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="col s12" v-if="showFormLead">
                                                    <DragAndDropFileUpload ref="fileUpload"
                                                        :msgAnexarDocs="env.msg_anexar_docs"
                                                        :tiposPermitidos="allowedExt" multiple height="160px" accept="
                                                            image/gif, 
                                                            image/png, 
                                                            image/jpg, 
                                                            image/jpeg, 
                                                            jimage/fif, 
                                                            application/pdf
                                                        " @files="files => arquivosAnexo = files" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="showListaEmails">
                                        <div class="container">
                                            <p>Selecione o email que deseja utilizar no seu cadastro.</p>
                                            <div class="collection">
                                                <a class="collection-item" v-for="(item, index) in listaEmailsCliente"
                                                    @click.prevent="selecionarEmailCadastro(item.email)"
                                                    :class="{ 'active': item.selecionado }" :key="index">{{ item.email }}</a>
                                            </div>
                                            <div><span>ou clique <a
                                                        @click.prevent="enviaSolicitacaoAtualizacaoCadastro(env.quero_acessar_titulo_escolha_outro_email)"
                                                        href="">aqui</a> caso nenhum dos e-mails acima seja o
                                                    correto.</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider mt-1"></div>
                                <div class="col s12 mt-1">
                                    <a @click.prevent="voltarPagLogin" id="btn-logar"
                                        class="btn waves-effect waves-light left col ma-0 s4">
                                        Voltar
                                    </a>
                                    <a v-if="!showFormLead" @click.prevent="buscarEmailCliente"
                                        id="btn-buscar-email-cliente" class="btn waves-effect waves-light right col s4"
                                        :class="{ 'disabled': showListaEmails == true || showInfoTelefone == true }">
                                        <i class="material-icons">send</i>
                                    </a>
                                    <a class="waves-effect waves-light btn right col s4"
                                        :class="{ 'disabled': loaderQueroAcessar.length > 0 }"
                                        @click.prevent="capturarLeadClienteSemCadastro" v-if="showFormLead">
                                        <i class="material-icons">send</i>
                                    </a>
                                </div>
                                <div class="row">
                                    <div class="container">
                                        <div v-if="mensagem_esqueci_senha" id="card-alert-login"
                                            class="card red lighten-5">
                                            <div class="card-content red-text">
                                                <p>{{ mensagem_esqueci_senha }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <simple-dialog :show="mostrarVisualizacao" @onClose="mostrarVisualizacao = false">
            <div slot="">
                <div class="row">
                    <div class="col s12">
                        <p>{{ msg_modal }}</p>
                    </div>
                </div>
            </div>
        </simple-dialog>
    </div>
</template>
<script>
import ServiceFactory from '../../services/ServiceFactory';
import SpinnerLoader from '../spinnerLoader/SpinnerLoader.vue';
import StHelper from '../../helpers/StHelper';
import SimpleDialog from '../dialog/SimpleDialog.vue';
import Vue from 'vue';
import { Validator } from 'vee-validate';
import FloatThead from '../FloatThead/FloatThead.vue';
import DragAndDropFileUpload from '../dragAndDropFileUpload/DragAndDropFileUpload.vue';
import ShowContentHelper from "../../helpers/ShowContentHelper";

export default {
    components: {
        SpinnerLoader, SimpleDialog, FloatThead, DragAndDropFileUpload
    },
    name: 'pagina-login',
    props: {
        logo: { type: String, default: null },
        background: { type: String, default: null },
        tema: { type: String, default: null },
        exibirErros: { type: Boolean, default: true },
    },
    data() {
        return {
            lembrar: true,
            obj_auth: {
                'client_id': 'SITE',
                'grant_type': 'password',
                username: '',
                password: '',
                client_secret: 'PIPUSQUAQUE_FUJAO'
            },
            mensagem_login: '',
            mensagem_esqueci_senha: '',
            loginService: null,
            cliente_service: null,
            emailRecuperacaoSenha: null,
            usuarioEmailDuplicado: null,
            loginRecuperacaoSenha: '',
            textoRetornoRecuperarSenha: false,
            loaderEsqueciSenha: [],
            loaderLogin: [],
            loaderQueroAcessar: [],
            mostrarVisualizacao: false,
            usuario: null,
            msg_modal: null,
            novaSenhaService: null,
            exibirPaginaLogin: true,
            esqueceuSenha: false,
            leadCliente: false,
            cnpjCliente: null,
            listaEmailsCliente: [],
            showListaEmails: false,
            showInfoTelefone: false,
            showFormLead: false,
            novoUsuarioCliente: null,
            lead_service: null,
            lead: null,
            cliente: null,
            env_service: null,
            env: null,
            tituloFuncaoQueroAcessar: null,
            windowHeight: 0,
            windowWidth: 0,
            arquivosAnexo: [],
            sch: new ShowContentHelper(),
            allowedExt: ['gif', 'png', 'jpg', 'jpeg', 'fif', 'pdf'],
        }
    },

    mounted() {
        this.defineTelaDispositivo();
    },

    computed: {
        extPermitida: function () {
            return this.$refs.fileUpload.extPermitida;
        },
    },

    watch: {
        arquivosAnexo: function (newValue) {
            if (!this.extPermitida) this.msgExtNaoPermitida();
        },
    },

    destroyed() {
        window.removeEventListener("resize", this.defineTelaDispositivo);
    },

    created() {
        window.addEventListener("resize", this.defineTelaDispositivo);
        this.loadResources();  
    },
    methods: {
        loadResources() {
            let serviceFactory = new ServiceFactory(this.$http);
            serviceFactory.login()
                .then(serv => this.loginService = serv)
                .then(() => serviceFactory.usuario())
                .then(serv => this.usuario = serv)
                .then(() => serviceFactory.novaSenha())
                .then(serv => this.novaSenhaService = serv)
                .then(() => serviceFactory.cliente())
                .then(serv => this.cliente_service = serv)
                .then(() => serviceFactory.lead())
                .then(serv => this.lead_service = serv)
                .then(() => this.lead_service.gerarBeanNovoLead())
                .then(bean => this.lead = bean)
                .then(() => serviceFactory.env())
                .then(serv => this.env_service = serv)
                .then(() => this.env_service.obterMapa())
                .then(env => this.env = env)
                .then(() => this.loginService.autenticarComTokenPrevio())
                .then(auth => {
                    if (auth) {
                        this.$emit('onLoginSuccess', auth);
                    }
                    return true;
                })
                .catch(err => this.showError(err));
        },
        defineTelaDispositivo(e) {
            this.windowHeight = $(window).height();
            this.windowWidth = $(window).width();

            if (this.windowWidth < 450 && this.windowWidth < this.windowHeight) {
                setTimeout(() => $(this.$refs.containerLogin.scrollTo(0, 10), 50)) // desloca até o final da tela
            }
        },

        showError(response) {
            console.log('Exibir Errors', this.exibirErros);
            if (this.exibirErros) {
                if (typeof (response) == 'string') {
                    this.mensagem_login = response;
                } else if (response.body && response.body.title) {
                    this.mensagem_login = response.body.title;
                    if (response.body.detail) this.mensagem_login = `${response.body.title}\n${response.body.detail}`;
                } else if (response.status == 401) {
                    this.mensagem_login = this.env.quero_acessar_cliente_bloqueado;
                } else if (response.status == 409) {
                    this.mensagem_login = this.env.quero_acessar_texto_usuario_ja_existe;
                } else if (response.status = 401) {
                    this.mensagem_login = `Sua Autenticação expirou (você deve ter acessado em outro navegador/computador), faça login novamente (isso invalidará sua autenticação em outros navegadores).`;
                } else {
                    this.mensagem_login = response;
                }
                StHelper.toastAlerta(this.mensagem_login);
            }
        },
        showErrorEsqueciSenha(response) {
            if (response.body && response.body.title) {
                this.mensagem_esqueci_senha = response.body.title;
                if (response.body.detail)
                    this.mensagem_esqueci_senha += ': ' + response.body.detail;
            } else {
                this.mensagem_esqueci_senha = response;
            }
        },
        efetuarLogin() {
            this.isLogged = false;
            this.mensagem_login = '';
            if (!this.obj_auth.username || !this.obj_auth.password) return StHelper.toastAlerta('Nome de usuário ou senha vazios.');
            this.loaderLogin.push(1);
            this.$validator.validateAll('formLogin')
                .then(resultOk => resultOk ? this.loginService.autenticar(this.obj_auth, this.lembrar) : Promise.reject('Problema no formulário'))
                .then((auth) => {
                    if (auth.stUsuario.usuaTextoBloqueio) {
                        this.showError(auth.stUsuario.usuaTextoBloqueio);
                        // this.loginService.bloquearUsuariosPreposto(auth);
                    } else {
                        this.$emit('onLoginSuccess', auth);
                    }
                })
                .catch((response) => {
                    if (response.msg && response.msg.includes('vee-validate')) {
                        this.showError('Por favor informe seu login e senha!');
                    } else {
                        if (response.status == 500) {
                            console.error(response);
                            this.showError('Não foi possível acessar com sua conta, se o problema persistir entre em contado com administrador do sistema!');
                            return;
                        }
                        this.showError(response);
                    }
                })
                .then(() => this.loaderLogin.pop());
        },
        recuperarSenha() {
            this.mensagem_esqueci_senha = '';
            this.loaderEsqueciSenha.push(1);
            this.$validator.validateAll()
                .then(resultOk => {
                    if (resultOk && StHelper.validaFormatoEmail(this.emailRecuperacaoSenha)) {
                        this.novaSenhaService.verificaStatusUsuario(this.emailRecuperacaoSenha, this.loginRecuperacaoSenha)
                            .then((situacao) => {
                                if (situacao && situacao != 'OK') {
                                    const msg = situacao.msg;
                                    if (!!msg && msg.length > 0) {
                                        this.msg_modal = msg;
                                        this.textoRetornoRecuperarSenha = "RecuperacaoSenhaResource.usuario_email_duplicado, RecuperacaoSenhaResource.usuario_login_nao_encontrado".includes(situacao.codError);
                                    } else {
                                        this.msg_modal = situacao;
                                        this.mostrarVisualizacao = true;
                                    }
                                } else {
                                    this.novaSenhaService.enviaEmailTrocaSenha(this.emailRecuperacaoSenha, this.loginRecuperacaoSenha)
                                        .then(() => {
                                            this.msg_modal = `Um email foi enviado para o endereço: ${this.emailRecuperacaoSenha} com as instruções para recuperar a sua senha.`;
                                            this.mostrarVisualizacao = true;
                                            this.voltarPagLogin();
                                        })
                                        .catch(err => {
                                            if (err.status == 404)
                                                this.showErrorEsqueciSenha(`Não foi possível localizar o email do seu usuário, favor entrar em contato com o administrador do sistema`);
                                            else if (err.status == 403)
                                                this.showErrorEsqueciSenha(`Ocorreu um problema com o email do seu usuário, favor entrar em contato com o administrador do sistema`);
                                            else if (err.status == 400)
                                                this.showErrorEsqueciSenha(`Ocorreu um problema de aprovação com seu usuário, favor entrar em contato com o administrador do sistema`);
                                            else if (err.status == 0)
                                                this.showErrorEsqueciSenha(`Sem conexão com o servidor, favor entrar em contato com o administrador de infra do sistema ou tente novamente mais tarde.`);
                                            else
                                                this.showErrorEsqueciSenha(err);
                                        });
                                }
                            })
                            .catch(err => this.showErrorEsqueciSenha(err));
                    } else {
                        StHelper.toastAlerta("Email inválido");
                        this.emailRecuperacaoSenha = null;
                        this.loaderEsqueciSenha.pop();
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.showErrorEsqueciSenha('Desculpe, houve um problema com a sua solicitação. Tente novamente mais tarde');
                })
                .then(() => this.loaderEsqueciSenha.pop());
        },
        esqueciSenha() {
            this.esqueceuSenha = true;
            this.exibirPaginaLogin = false;
            this.leadCliente = false;
        },
        voltarPagLogin() {
            this.esqueceuSenha = false;
            this.exibirPaginaLogin = true;
            this.leadCliente = false;
            this.emailRecuperacaoSenha = null;
            this.cnpjCliente = null;
            this.showFormLead = false;
            this.textoRetornoRecuperarSenha = false;
            this.loginRecuperacaoSenha = '';
            this.loaderQueroAcessar.pop();
            this.limparCamposFuncaoQueroAcessar();
        },
        queroAcessar(event) {
            let serviceFactory = new ServiceFactory(this.$http);

            serviceFactory.env()
                .then(serv => this.env_service = serv)
                .then(() => this.env_service.obterMapa())
                .then(env => this.env = env)
                .then(() => {
                    this.tituloFuncaoQueroAcessar = this.env && this.env.quero_acessar_titulo_cnpj;
                    this.esqueceuSenha = false;
                    this.exibirPaginaLogin = false;
                    this.leadCliente = true;
                })
                .catch(err => this.showError(err));
        },
        buscarEmailCliente() {
            this.loaderQueroAcessar.push(1);
            if (this.cnpjCliente) {
                this.cnpjCliente = StHelper.removeCaracteresEspeciais(this.cnpjCliente);
                this.cliente_service.getClienteByCNPJ(this.cnpjCliente)
                    .then(clie => {
                        this.cliente = clie;
                        if (!this.cliente) {
                            if (!StHelper.validarCnpj(this.cnpjCliente)) {
                                this.loaderQueroAcessar.pop();
                                StHelper.toastAlerta('Favor informar CNPJ válido.');
                            } else {
                                this.tituloFuncaoQueroAcessar = this.env.quero_acessar_titulo_captura_lead;
                                this.showFormLead = true;
                                this.showListaEmails = false;
                            }
                        } else {
                            let emails = [];
                            if (this.cliente.clieEmail) emails.push(this.cliente.clieEmail);
                            if (this.cliente.clieEmailsAdicionais) emails.push(...this.cliente.clieEmailsAdicionais.split(/,|;/g));
                            if (emails.length > 0) {
                                emails.map(email => this.listaEmailsCliente.push({ selecionado: false, email }));
                                this.showListaEmails = true;
                                this.usuario.usuarioNovo()
                                    .then(novoUsuario => {
                                        novoUsuario.usuaLogin = this.cliente.clieCnpj;
                                        novoUsuario.usuaNome = this.cliente.clieNome;
                                        novoUsuario.usuaSituacao = 'A';
                                        novoUsuario.usuaInConvite = 'S';
                                        novoUsuario.usuaInAprovado = 'S';
                                        novoUsuario.usuaRole = 'CLIENTE';
                                        novoUsuario.usuaTelefone = this.cliente.clieTelefone;
                                        novoUsuario.empresa = this.cliente.empresa;
                                        novoUsuario.unidadeNegocio = this.cliente.unidadeNegocio;
                                        novoUsuario.usuaRefExterno = this.cliente.clieRefExterno;
                                        this.novoUsuarioCliente = novoUsuario;
                                        this.loaderQueroAcessar.pop();
                                    })
                                    .catch(err => {
                                        this.lancarErroFuncaoQueroAcessar(err);
                                        this.loaderQueroAcessar.pop();
                                    });
                            } else {
                                this.enviaSolicitacaoAtualizacaoCadastro(this.env.quero_acessar_titulo_escolha_outro_email);
                            }
                        }
                    })
                    .then(() => this.loaderQueroAcessar.pop())
                    .catch(err => {
                        this.lancarErroFuncaoQueroAcessar(err);
                        this.loaderQueroAcessar.pop();
                    });
            } else {
                StHelper.toastAlerta('O campo CNPJ é obrigatório.');
                this.loaderQueroAcessar.pop();
            }
        },
        selecionarEmailCadastro(emailSelecionadoParaCadastro) {
            this.novoUsuarioCliente.usuaEmail = emailSelecionadoParaCadastro;
            this.showListaEmails = false;
            this.salvarClienteComoUmUsuario();
        },
        salvarClienteComoUmUsuario() {
            this.loaderQueroAcessar.push(1);
            this.usuario.salvarClienteComoUmUsuario(this.novoUsuarioCliente)
                .then(() => {
                    this.lancarMensagemSucesso('Um email foi enviado para o endereço informado com as instruções para finalizar o seu cadastro no e-commerce.');
                    this.voltarPagLogin();
                    this.loaderQueroAcessar.pop();
                })
                .catch(err => {
                    this.lancarErroFuncaoQueroAcessar(err);
                    this.loaderQueroAcessar.pop()
                });
        },
        enviaSolicitacaoAtualizacaoCadastro(titulo) {
            this.lead.cliente = this.cliente;
            this.lead.leadCnpj = this.cliente.clieCnpj;
            this.lead.leadNomeEmpresa = this.cliente.clieNome;
            this.tituloFuncaoQueroAcessar = titulo;
            this.showFormLead = true;
            this.showListaEmails = false;
        },
        capturarLeadClienteSemCadastro() {
            if (!this.cnpjCliente) {
                StHelper.toastAlerta('Favor informar CNPJ');
            } else {
                if (!StHelper.validarCnpj(this.cnpjCliente) && !this.lead.leadCnpj) {
                    StHelper.toastAlerta('Favor informar CNPJ válido.');
                } else {
                    if (!this.lead.leadCnpj) this.lead.leadCnpj = this.cnpjCliente;
                    if (!this.lead.leadContato) StHelper.toastAlerta('Favor informar um contato');
                    else if (!this.lead.leadNomeEmpresa) StHelper.toastAlerta('Favor informar o nome da empresa');
                    else if (!this.lead.leadTelefone || this.validaTelefona()) StHelper.toastAlerta('Favor informar um telefone inválido');
                    else if (!this.lead.leadEmail) StHelper.toastAlerta('Favor informar um email');
                    else if (!this.arquivosAnexo.length > 0) StHelper.toastAlerta('Favor anexar pelo menos um arquivo');
                    else if (!this.extPermitida) this.msgExtNaoPermitida();
                    else {
                        this.loaderQueroAcessar.push(1);
                        let lead = JSON.parse(JSON.stringify(this.lead)); // clona variável sem referenciar a original 
                        lead.leadTelefone = lead.leadTelefone.replace(/[^0-9]/g, "");

                        this.lead_service.gravarLead(lead, this.arquivosAnexo)
                            .then(res => {
                                this.voltarPagLogin();
                                this.lancarMensagemSucesso(this.env.quero_acessar_lead_capturado_sucesso);
                                this.loaderQueroAcessar.pop();
                            })
                            .catch(err => {
                                this.showError(err);
                                this.loaderQueroAcessar.pop();
                            });
                    }
                }
            }
        },
        lancarMensagemSucesso(mensagem) {
            //   this.showError = null;
            this.msg_modal = mensagem;
            this.mostrarVisualizacao = true;
            this.limparCamposFuncaoQueroAcessar();
        },
        lancarErroFuncaoQueroAcessar(err) {
            this.limparCamposFuncaoQueroAcessar();
            this.showError(err);
            this.voltarPagLogin();
        },
        limparCamposFuncaoQueroAcessar() {
            this.listaEmailsCliente = [];
            this.cnpjCliente = null;
            this.novoUsuarioCliente = null;
            this.showListaEmails = false;
            this.showFormLead = false;
            this.limparArquivosAnexo();
            this.lead_service.gerarBeanNovoLead().then(bean => this.lead = bean);
        },
        limparArquivosAnexo() {
            this.arquivosAnexo = [];
        },
        msgExtNaoPermitida() {
            const allowedExt = this.allowedExt.toString().replaceAll(',', ', ');
            StHelper.toastAlerta(`Arquivo selecionado não permitido. Escolha um arquivo válido (${allowedExt})`);
        },
        validaTelefona() {
            let exp = /^([0-9][0-9])((9)\d{8}|\d{8})$/g;
            return exp.test(this.lead.leadTelefone);
        },

        formataTelefone() {
            const telefone = this.lead.leadTelefone;
            const soNumeros = telefone.replace(/[^0-9]/g, "");
            const formato = (soNumeros[2] == '9') ? '(**) * ****-****' : '(**) ****-****';

            let chars = soNumeros.split('');
            let count = 0;
            let formatted = '';

            for (let i = 0; i < formato.length; i++) {
                const c = formato[i];
                if (chars[count]) {
                    if (/\*/.test(c)) {
                        formatted += chars[count];
                        count++;
                    } else {
                        formatted += c;
                    }
                }
            }
            this.lead.leadTelefone = formatted;
        },
    }
}

</script>

<style lang="scss" scoped>
/* Remove Arrows/Spinners Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Remove Arrows/Spinners Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

.preto_branco {
    filter: grayscale(1);
}

.centralize-forced {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
}

.container-login {
    top: 0;
    padding: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    height: 100vh;
    overflow: auto;
    margin: 0;

    .negrito {
        font-weight: bold !important;
        font-size: 21px;
    }

    .fullHeight {
        height: 100%;
    }

    .sub-container {
        height: 100%;

        .sub-container-logo {
            height: 100%;

            .logo {
                max-width: 360px;
                padding-top: 1.5rem;

                .btn {
                    margin-bottom: 20px;
                }

                img {
                    width: 100%;
                    margin: 0;
                }

                span {
                    font-size: 23px;
                    font-weight: bold;
                }
            }
        }

        .sub-container-form-login {
            height: 100%;

            &.centralize-forced {

                .card-login {
                    width: 600px;
                    max-width: 600px;
                    overflow-x: hidden;
                }
            }


            .card-login {
                border: 2px solid #aaa;
                padding: 20px 0;
                width: 350px;
                max-width: 350px;


                /* &.center_container {
                        margin: 0 50% !important;
                        max-width: none;
                    } */

                .title-form-login {
                    font-size: 30px;
                    font-weight: bold;
                    margin: 0;
                }

                .flexbox {
                    display: flex;
                    justify-content: space-between;
                    font-size: 13px;
                    margin: 0;

                    .col {
                        padding: 0;
                    }

                    label {
                        position: relative;
                        top: 0;
                        color: #3949ab;
                        left: 0 !important;
                        padding-left: 25px;
                        font-size: 13px;
                    }

                    a {
                        color: #3949ab;
                        font-size: 13px;
                        line-height: 2;
                    }
                }
            }
        }

        .logo,
        .card-login {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            margin: 30px;
            padding: 30px 20px;
        }

        .input-field i {
            padding: 6.7px !important;
            z-index: 10;
        }
    }

    .p-0 {
        padding: 0 !important;
    }

    .m-0 {
        margin: 0 !important;
    }

    .picker__footer {
        text-align: left;
    }

    .input-field label {
        padding-left: .5rem;
        font-size: 1.1rem;
    }

    form .row {
        margin: 0;
    }

    .input-field label:not(.label-icon).active,
    input[type=text]:focus:not([readonly])+label,
    input[type=password]:focus:not([readonly])+label {
        display: none;
        box-sizing: border-box !important;
    }

    .input-field input {
        font-size: 1.2rem;
        opacity: 0.6;
    }

    .formLogin div:first-child span a {
        height: 30px;
        line-height: 30px;
        width: 160px;
    }

    #username,
    #password,
    #clienteCNPJ,
    #email {
        margin: 0;
        padding-left: 3.5rem;
        box-sizing: border-box;
        margin-bottom: 10px;
    }

    #clienteCNPJ {
        padding-left: 20px;
    }

    #btn-logar {
        margin-bottom: 1px;
    }
}


/* ------------------  tablet  ------------------ */
@media (max-width:1024px) {
    .container-login {
        .row {
            .sub-container {
                max-width: 350px;
                position: relative;
                left: 50% !important;
                transform: translateX(-50%) !important;

                .sub-container-logo {
                    margin-bottom: 1.5rem;

                    .logo {
                        margin: 0 !important;
                        max-width: unset;

                        img {
                            width: 80%;
                            margin-top: 0;
                            padding: 0 !important;
                            margin: 0;
                        }
                    }
                }

                .sub-container-form-login {
                    .card-login {
                        margin-left: 0;

                        .title-form-login {
                            font-size: 3.7vw;
                        }

                        .formLogin div:first-child span a {
                            height: 36px;
                            line-height: 36px;
                            width: inherit;
                            margin: 10px 0;
                        }

                        .flexbox {
                            .col {
                                padding: 0;
                            }
                        }
                    }
                }

                .sub-container-logo,
                .sub-container-form-login {
                    height: auto;
                    display: flex;
                    justify-content: center;
                }

                .logo,
                .card-login {
                    position: relative;
                    transform: unset;
                    /* max-width: none; */
                    margin: 0px;
                    padding: 5px 0;
                }
            }
        }
    }
}


/* ------------------  celular com teclado ativado  ------------------ */
.container-login {
    &.tela-vertical {
        img.background-img {
            height: calc(100vh + 110px);
        }
    }

    &.vertical-teclado-ativado {
        img.background-img {
            height: calc(100vh + 25.5rem);
        }
    }
}

.container-login {
    &.tela-horizontal {
        img.background-img {
            height: calc(100vh + 370px);
        }
    }

    &.horizontal-teclado-ativado {
        img.background-img {
            height: calc(100vh + 500px);
        }
    }
}


/* ------------------  celular ------------------ */
@media (max-width:600px) {
    .container-login {
        .row {
            .sub-container {

                .sub-container-logo,
                .sub-container-form-login {
                    padding: unset !important;
                }

                .sub-container-logo {
                    .logo {
                        span {
                            font-size: 8vw;
                        }

                        a {
                            width: 100% !important;
                        }
                    }
                }

                .sub-container-form-login {
                    .card-login {
                        position: 0 !important;
                        margin-right: 0 !important;

                        .title-form-login {
                            font-size: 8.5vw;
                        }

                        .flexbox {
                            .col {
                                padding: 0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// PaginaLogin.vue?d1bfcd48